module.exports = __webpack_public_path__ + "static/media/evan_stites_clayton.8f218f0d.jpg";